const titleOptions = ["Mr", "Ms", "Miss", "Mrs", "Dr", "Prof", "Sr"];

export default titleOptions;
